import { RECOMMENDATION } from "../actionTypes";
import { deepClone } from "../../utils/global_functions";
import { _recommendation } from "../../controllers";
import { _getWhatsHotData } from "../../controllers/watchlist";
import { getWhatsHotDataSuccess } from "./dontMiss";
import { getOrderCartById } from "../../apis/transactional";


export const recommendation = (allowedNewsCat, pageNo, pageSize) => async (dispatch, getState) => {

    const whatsHotData = deepClone(getState().dontMiss?.whatsHotData);
    const holdingsScrips = deepClone(getState().holdings?.holdingsScrips);
    //Prachi T :BT-107377 - 15-11-2023 ScripInnfo recommendations - Start
    let arrWhatsHotData = [];
    if (whatsHotData?.length > 0) {
        arrWhatsHotData = whatsHotData;
    } else {
        const arrWhatsHotDataFromApi = await _getWhatsHotData();
        arrWhatsHotData = arrWhatsHotDataFromApi?.data?.data?.result?.length > 0 ? arrWhatsHotDataFromApi?.data?.data?.result : [];
        dispatch(getWhatsHotDataSuccess(arrWhatsHotData));
    }

    const objresponse = await _recommendation(allowedNewsCat, pageNo, pageSize, arrWhatsHotData, holdingsScrips);
    //Prachi T :BT-107377 - 15-11-2023 ScripInnfo recommendations - End
    // Hari K : 09-08-2023 get the scrip information of recommendations-start
    // const arrUniqueScrips = [];
    // const seenCombination = {};
    // objresponse?.data?.recommendations?.forEach(element => {
    //     const segmentAndToken = `${element.nMarketSegmentId}-${element.nToken}`;
    //     if (!seenCombination[segmentAndToken]) {
    //         seenCombination[segmentAndToken] = true;
    //         arrUniqueScrips.push({ "mkt": getApiExchangeNameFromMktSegId(element?.nSegmentId), "token": element.nToken });
    //     }
    // });
    // dispatch(getScripInfo(arrUniqueScrips));

    // Hari K : 09-08-2023 get the scrip information of recommendations-end

    if (objresponse.status && objresponse?.data?.recommendations?.length > 0) {
        dispatch(recommendationSuccess(objresponse.data.recommendations));
        dispatch(recommendationTagsSuccess(objresponse.data)); //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
        return Promise.resolve(objresponse.data.recommendations);

    } else {
        dispatch(recommendationFailure([]));
        return [];
    }

};

//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
export const getBasketRecoData = (cartId) => async (dispatch, getState) => {
    // BREEZE-8190 : Basket Order  Recommendation : ManasaB : 08-09-2025 : SAT 2 issue - Start 
    let objRep = await getOrderCartById({ orderCartId: cartId });
    const productTypes = deepClone(getState().orders?.productTypes);
    dispatch(getBasketRecoScrips(objRep?.data.data));
    let arrOrderCart = objRep?.data.data.orders;
    let data = [];
    for (let i = 0; i < arrOrderCart?.length; i++) {
        let objProductType = productTypes?.find(ele => ele?.sDefaultProductType === arrOrderCart[i]?.scripDetail?.ProductType);
        let strProductType = '';
        if (objProductType && Object.keys(objProductType).length !== 0) {
            strProductType = objProductType?.sDescription;
        }
        data.push({
            id: `${arrOrderCart[i].scripDetail.scripDet._MktSegId}_${arrOrderCart[i].scripDetail.scripDet.token}`,
            'BUY/SELL': arrOrderCart[i].scripDetail.TransactionType,
            'SYMBOL': arrOrderCart[i].scripDetail.symbol,
            'EXCHANGE': arrOrderCart[i].scripDetail._ExchangeName,
            "ORDER TYPE": arrOrderCart[i].scripDetail.OrderType,
            "VALIDITY": arrOrderCart[i].scripDetail.validity,
            "QTY": arrOrderCart[i].scripDetail.Quantity,
            "PRICE": arrOrderCart[i].scripDetail.Price,
            "PROD TYPE": strProductType.length > 0 ? strProductType : arrOrderCart[i].scripDetail.ProductType,
            "LTP": '0.00',
            "CLTP": '0.00',
            "SERIES": arrOrderCart[i].scripDetail._Series,
            "LTPPERCENT": '0.00',
            "TOKEN": arrOrderCart[i].scripDetail.scripDet.token,
            "EXCHANGEID": arrOrderCart[i].scripDetail.scripDet._MktSegId,
            "DECIMALLOCATOR": arrOrderCart[i].scripDetail.DecimalLocator,
            "ISINCODE": arrOrderCart[i].scripDetail.ISIN,
            "MARKETLOT": arrOrderCart[i].scripDetail.MarketLot,
            "PRICETICK": arrOrderCart[i].scripDetail.PriceTick,
            "INSTRUMENT": arrOrderCart[i].scripDetail._InstrumentName,
            "SECURITYDESC": arrOrderCart[i].scripDetail.SecurityDesc,
            "MAPPEDMKTSEGID": arrOrderCart[i].scripDetail.scripDet._MapMktSegId
        });
        // BREEZE-8190 : Basket Order  Recommendation : ManasaB : 08-09-2025 : SAT 2 issue - End
    }
    dispatch(updateBasketReco(data));
};
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
export const recommendationTags = (arrBrokerTags) => async (dispatch) => {
    dispatch(recommendationBrokerTagsSuccess(arrBrokerTags));
};

export const recommendationBrokerTagsSuccess = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_BROKER_TAGS, payload };
};

export const recommendationTagsSuccess = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_TAGS, payload };
};

export const recommendationSuccess = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_SUCCESS, payload };
};

export const recommendationFailure = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_FAILURE, payload };
};

export const topTenRecommendation = (payload) => {
    return { type: RECOMMENDATION.TOP_TEN_RECOMMENDATIONS, payload };
};
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
export const getBasketRecoScrips = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_BASKET, payload };
};
export const updateBasketReco = (payload) => {
    return { type: RECOMMENDATION.UPDATE_ARR_BASKET_RECO, payload };
};
export const updateCartCount = (payload) => {
    return { type: RECOMMENDATION.UPDATE_CART_COUNT, payload };
};
export const updateForwardIconStatus = (payload) => {
    return { type: RECOMMENDATION.UPDATE_FORWARD_ICON_STATUS, payload };
};
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End


